import React, { useEffect, useRef } from "react";
import * as THREE from "three";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "./whychooseus.css";
import { LuIndianRupee } from "react-icons/lu";
import { BiShieldAlt2 } from "react-icons/bi";
import { TbSend } from "react-icons/tb";
import { MdOutlineRule } from "react-icons/md";

const WhyChooseUs = () => {
  const bgRef = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    // === THREE.js Setup ===
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      75,
      bgRef.current.clientWidth / bgRef.current.clientHeight,
      0.1,
      1000
    );
    const renderer = new THREE.WebGLRenderer({ alpha: true });
    renderer.setSize(bgRef.current.clientWidth, bgRef.current.clientHeight);
    bgRef.current.appendChild(renderer.domElement);

    const geometry = new THREE.SphereGeometry(0.2, 16, 16);
    const material = new THREE.MeshStandardMaterial({
      color: 0x00ff7f,
      metalness: 0.8,
      roughness: 0.3,
    });
    const spheres = [];

    for (let i = 0; i < 25; i++) {
      const sphere = new THREE.Mesh(geometry, material);
      sphere.position.set(
        (Math.random() - 0.5) * 8,
        (Math.random() - 0.5) * 4,
        (Math.random() - 0.5) * 6
      );
      scene.add(sphere);
      spheres.push(sphere);
    }

    const light = new THREE.PointLight(0xffffff, 1);
    light.position.set(2, 2, 5);
    scene.add(light);
    camera.position.z = 5;

    const animate = () => {
      requestAnimationFrame(animate);
      spheres.forEach((s) => {
        s.rotation.x += 0.01;
        s.rotation.y += 0.01;
      });
      renderer.render(scene, camera);
    };
    animate();

    const handleResize = () => {
      if (!bgRef.current) return;
      renderer.setSize(bgRef.current.clientWidth, bgRef.current.clientHeight);
      camera.aspect = bgRef.current.clientWidth / bgRef.current.clientHeight;
      camera.updateProjectionMatrix();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (bgRef.current && renderer.domElement.parentNode === bgRef.current) {
        bgRef.current.removeChild(renderer.domElement);
      }
      renderer.dispose();
      scene.clear();
    };
  }, []);

  const features = [
    {
      icon: <LuIndianRupee />,
      title: "Instant Loan Approval",
      desc: "Experience hassle-free instant loan approvals powered by AI-based verification.",
    },
    {
      icon: <BiShieldAlt2 />,
      title: "Secure & Trusted",
      desc: "Your personal and financial data is secured with industry-grade encryption.",
    },
    {
      icon: <TbSend />,
      title: "Fast Disbursal",
      desc: "Get funds credited to your account instantly after approval — no waiting.",
    },
    {
      icon: <MdOutlineRule />,
      title: "Transparent Process",
      desc: "We believe in clarity — no hidden fees, no surprises, only honesty.",
    },
  ];

  return (
    <section className="whychooseus-section py-3">
      {/* 3D Spheres Background */}
      <div className="three-bg" ref={bgRef}></div>

      {/* Layered Cutted Background */}
      <div className="cut-bg">
        <div className="layer"></div>
      </div>

      <div className="container position-relative">
        {/* Glitch Heading */}
        <div className="text-center mb-5" data-aos="fade-up">
          <h6 className="wcus-pre-header">Why Choose Us</h6>
          <h2 className="wcus-main-title">
            We Make <span className="wcus-glitch-text" data-text="Your Financial Journey Effortless">
              Your Financial Journey Effortless
            </span>
          </h2>
          <p className="wcus-intro-text">
            From instant approvals to transparent processing, we’re redefining
            loan experiences with speed, security, and simplicity.
          </p>
        </div>

        <div className="row justify-content-center">
          {features.map((item, index) => (
            <div
              key={index}
              className="col-md-6 col-lg-3 mb-4"
              data-aos="zoom-in"
              data-aos-delay={index * 150}
            >
              <div className="choose-card">
                <div className="choose-icon-wrapper">
                  <div className="choose-icon">{item.icon}</div>
                </div>
                <h5>{item.title}</h5>
                <p>{item.desc}</p>
                <span className="glow-effect"></span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
